export interface IUnitNodePermission {
    code: string;
    level: number;
    levelA: number; //Additional permission A
    levelB: number; //Additional permission B
    levelC: number; //Additional permission C
    type: number;
    groupType: number;
    companyIds: string[]; //Partner Company Ids
}

export class UnitNodePermission implements IUnitNodePermission {
    code: string;
    level: number;
    levelA: number; //Additional permission A
    levelB: number; //Additional permission B
    levelC: number; //Additional permission C
    type: number;
    groupType: number;
    companyIds: string[]; //Partner Company Ids

    constructor();
    constructor(obj: IUnitNodePermission);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || 0;
        this.levelA = obj && obj.levelA || 0;
        this.levelB = obj && obj.levelB || 0;
        this.levelC = obj && obj.levelC || 0;
        this.type = obj && obj.type || 0;
        this.groupType = obj && obj.groupType || 0;
        this.companyIds = obj && obj.companyIds || [];
    }

    static getTotalPermission(level: number, levelA: number, levelB: number, levelC: number): number {
        return level * 1000 + levelA * 100 + levelB * 10 + levelC;
    }

    getLevelTotal(): number {
        return UnitNodePermission.getTotalPermission(this.level, this.levelA, this.levelB, this.levelC);
    }

    getAdditionalPermissionUnion(other: IUnitNodePermission): UnitNodePermission {
        if (other == null) return this;
        const result = new UnitNodePermission(this);
        result.levelA = Math.max(result.levelA, other.levelA);
        result.levelB = Math.max(result.levelB, other.levelB);
        result.levelC = Math.max(result.levelC, other.levelC);
        return result;
    }
}